import React, { useState } from "react";
import "../Assets/Styles/form.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const GtaEn = () => {
  const [formData, setFormData] = useState({
    sl: "",
    ph: "",
    body: "",
    cta: "",
    trackingCode: "",
    trackingCodeHero: "",
    trackingCodeHeader: "",
    trackingCodeCta: "",
    trackingCodeBanner: "",
    trackingCodeFooter: "",
    ctaUrl: "",
    heroOneUrl: "",
    heroTwoUrl: "",
    heroThreeUrl: "",
    hero: "",
    heroUrl: "",
    tileTwoImg : "",
    tileThreeImg : "",
    showDiv: "No",
    hasBanner: "", 
    secondaryBanner: "",
    secondaryBannerUrl: "",
    tileFourImg : "",
  });

  const [showPreview, setShowPreview] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];
    if (file) {
      // Get the file name (basename) without path
      const fileName = file.name;
      
      // Generate a URL for the uploaded file
      const fileUrl = URL.createObjectURL(file);
  
      // Set both the file name (basename) and the file URL
      setFormData({ ...formData, [name]: { fileName, fileUrl } });
    }
  };
  const heroFileName = formData.hero?.fileName; 
  const tiletwoFileName = formData.tileTwoImg?.fileName; 
  const tilethreeFileName = formData.tileThreeImg?.fileName;
  const tilefourFileName = formData.tileFourImg?.fileName;
  const ctaFileName = formData.cta?.fileName; // "cta.jpg" // "secondary.jpg"
  const secondaryBannerFileName = formData.secondaryBanner?.fileName;
  
  const handleFormSubmit = (e) => {
    e.preventDefault();
    setShowPreview(true);
    saveAsHtmlFile()
  };

  const replaceFrenchCharacters = (text) => {
    const replacements = {
      é: "&eacute;",
      è: "&egrave;",
      ê: "&ecirc;",
      à: "&agrave;",
      ç: "&ccedil;",
      î: "&icirc;",
      ï: "&iuml;",
      ô: "&ocirc;",
      ù: "&ugrave;",
      û: "&ucirc;",
    };
    return text.replace(
      /[\u00E0-\u00FC]/g,
      (char) => replacements[char] || char
    );
  };

  const saveAsHtmlFile = async () => {
    const { sl, ph, body, trackingCode,trackingCodeHero,secondaryBanner,secondaryBannerUrl,trackingCodeHeader,trackingCodeCta,trackingCodeBanner,trackingCodeFooter ,ctaUrl,hasBanner ,heroOneUrl,heroTwoUrl, heroThreeUrl ,showDiv, heroUrl ,tileFourImg} = formData;

    const safeSl = replaceFrenchCharacters(sl);
    const safePh = replaceFrenchCharacters(ph);
    const safeBody = replaceFrenchCharacters(body);
    const fileName = trackingCode ? `${trackingCode.replace(/\s+/g, "_")}` : "Generated_email.html";

    const cvHtml = `
         <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml"
xmlns:v="urn:schemas-microsoft-com:vml"
xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
<title>${safeSl}</title>
<meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta name="format-detection" content="telephone=no"/>
<meta name="x-apple-disable-message-reformatting" content=""/>
<!--[if !mso]><!-->
<link type="text/css" href="https://fonts.googleapis.com/css?family=Roboto+Condensed:300,400,700" rel="stylesheet"  />
<link type="text/css" href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet" />
<!--<![endif]-->

<style type="text/css">
a[href^="x-apple-data-detectors:"] {
    color: inherit;
    text-decoration: inherit;
}
.appleLinks a {
    color: #000000;
    text-decoration: none;
}
.appleLinksWhite a {
    color: #ffffff;
    text-decoration: none;
}
.samsungLinks a {
    color: #666666;
    text-decoration: none;
}
body {
    margin: 0 auto !important;
    padding: 0 !important;
    -webkit-text-size-adjust: 100% !important;
    -ms-text-size-adjust: 100% !important;
    -webkit-font-smoothing: antialiased !important;
}
img {
    border: 0 !important;
    outline: none !important;
}
table {
    border-collapse: collapse;
    mso-table-lspace: 0px;
    mso-table-rspace: 0px;
}
td, a, span {
    border-collapse: collapse;
    mso-line-height-rule: exactly;
}
.ExternalClass * {
    line-height: 100%;
}
.em_defaultlink a {
    color: inherit !important;
    text-decoration: none !important;
}
span.MsoHyperlink {
    mso-style-priority: 99;
    color: inherit;
}
span.MsoHyperlinkFollowed {
    mso-style-priority: 99;
    color: inherit;
}
input {
    display: none !important;
}
/* CSS for hiding content in desktop/webmail clients */
.imghide {
    max-height: 0px;
    font-size: 0;
    display: none;
    overflow: hidden;
}

@media only screen and (min-width:481px) and (max-width:549px) {
.desk-visible {
    display: none;
}
.showmenu {
    display: block !important;
    width: auto !important;
    overflow: visible !important;
    float: none !important;
    max-height: inherit !important;
    max-width: inherit !important;
    line-height: normal !important;
    margin-top: 0px !important;
    visibility: inherit !important;
    border-bottom: 0 !important;
}
*[id]#nav_menu {
    background-color: #2a333b;
    max-height: 0;
    overflow: hidden;
    transition: max-height .25s linear;
}
*[id]#nav_handle {
    background: url("menu_icon_sprite.png") 0 0 no-repeat;
    background-size: 23px 36px !important;
    cursor: pointer;
    display: block !important;
    width: 23px !important;
    height: 18px !important;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
*[id]#em_drop:checked + div table #nav_handle {
    background: url("menu_icon_sprite.png") 0 -18px no-repeat;
}
*[id]#em_drop:checked ~ #nav_menu {
    display: block !important;
    max-height: 300px !important;
}
.em_main_table {
    width: 100% !important;
}
.em_wrapper {
    width: 100% !important;
}
.em_wrapper2 {
    width: 100% !important;
    display: block !important;
    text-align: center !important;
    line-height: 50px !important;
    font-size: 20px !important;
    border-top: 1px solid #ffffff;
}
.em_wrapper3 {
    width: 100% !important;
    display: block !important;
    text-align: center !important;
    font-size: 20px !important;
}
.em_side {
    width: 10px !important;
}
.em_hide {
    width: 100% !important;
    height: auto !important;
}
.em_img {
    width: 100% !important;
    height: auto !important;
}
.em_center {
    text-align: center !important;
}
.em_h20 {
    height: 20px !important;
    font-size: 0px !important;
    line-height: 0px !important;
}
.em_pad {
    padding-top: 20px !important;
}
.em_aside {
    padding: 0 10px !important;
}
.em_topbom {
    padding: 20px 0px !important;
}
div[class=em_hide_desktop] {
    display: table !important;
    float: none !important;
    width: 100% !important;
    overflow: visible !important;
    height: auto !important;
}
.em_f60 {
    font-size: 70px !important;
    line-height: 72px !important;
}
.em_f40 {
    font-size: 42px !important;
    line-height: 42px !important;
}
.em_h10 {
    height: 10px !important;
}
.em_h40 {
    height: 40px !important;
}
.em_h30 {
    height: 30px !important;
}
.em_br {
    display: block !important;
    padding: 0 0 5px 0 !important;
}
.em_hide1 {
    display: none !important;
}
.em_max375 {
    max-width: 375px !important;
}
}

@media screen and (max-width: 480px) {
.desk-visible {
    display: none;
}
.showmenu {
    display: block !important;
    width: auto !important;
    overflow: visible !important;
    float: none !important;
    max-height: inherit !important;
    max-width: inherit !important;
    line-height: normal !important;
    margin-top: 0px !important;
    visibility: inherit !important;
    border-bottom: 0 !important;
}
*[id]#nav_menu {
    background-color: #2a333b;
    max-height: 0;
    overflow: hidden;
    transition: max-height .25s linear;
}
*[id]#nav_handle {
    background: url("menu_icon_sprite.png") 0 0 no-repeat;
    background-size: 23px 36px !important;
    cursor: pointer;
    display: block !important;
    width: 23px !important;
    height: 18px !important;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
*[id]#em_drop:checked + div table #nav_handle {
    background: url("menu_icon_sprite.png") 0 -18px no-repeat;
}
*[id]#em_drop:checked ~ #nav_menu {
    display: block !important;
    max-height: 300px !important;
}
.em_main_table {
    width: 100% !important;
}
.em_wrapper {
    width: 100% !important;
}
.em_wrapper2 {
    width: 100% !important;
    display: block !important;
    text-align: center !important;
    line-height: 50px !important;
    border-top: 1px solid #ffffff;
    font-size: 20px !important;
}
.em_wrapper3 {
    width: 100% !important;
    display: block !important;
    text-align: center !important;
    line-height: 40px !important;
    font-size: 20px !important;
}
.em_side {
    width: 10px !important;
}
.em_hide {
    display: none !important;
}
.em_img {
    width: 100% !important;
    height: auto !important;
}
.em_center {
    text-align: center !important;
}
.em_h20 {
    height: 20px !important;
    font-size: 0px !important;
    line-height: 0px !important;
}
.em_pad {
    padding-top: 20px !important;
}
.em_aside {
    padding: 0 10px !important;
}
u + .em_body .em_full_wrap {
    width: 100% !important;
    width: 100vw !important;
}
.em_topbom {
    padding: 20px 0px !important;
}
div[class=em_hide_desktop] {
    display: table !important;
    float: none !important;
    width: 100% !important;
    overflow: visible !important;
    height: auto !important;
}
.em_f60 {
    font-size: 55px !important;
    line-height: 58px !important;
}
.em_f40 {
    font-size: 34px !important;
    line-height: 34px !important;
}
.em_h10 {
    height: 10px !important;
}
.em_h40 {
    height: 40px !important;
}
.em_h30 {
    height: 30px !important;
}
.em_br {
    display: block !important;
    padding: 0 0 5px 0 !important;
}
.em_hide1 {
    display: none !important;
}
.em_font12 {
    font-size: 10px !important;
    line-height: 14px !important;
}
.em_max375 {
    max-width: 375px !important;
}
.imghide {
    max-height: none !important;
    font-size: 12px !important;
    display: block !important;
}
*[class].width414 {
    width: 414px !important;
}
*[class].heightAuto {
    height: auto !important;
}
}

@media screen and (max-width: 414px) {
.desk-visible {
    display: none;
}
.imghide414 {
    max-height: none !important;
    font-size: 12px !important;
    display: block !important;
}
.em_hide414 {
    display: none !important;
}
.em_br414 {
    display: block !important;
    padding: 0 0 5px 0 !important;
}
.borders {
    border-left: 2px #333;
}
}
</style>
<!--[if gte mso 9]><xml>
<o:OfficeDocumentSettings>
<o:AllowPNG/>
<o:PixelsPerInch>96</o:PixelsPerInch>
</o:OfficeDocumentSettings>
</xml><![endif]-->
</head>
<body class="em_body" style="margin:0px; padding:0px;" bgcolor="#ffffff">
<table width="100%" border="0" cellspacing="0" cellpadding="0" class="em_full_wrap" bgcolor="#ffffff">
  <tr>
    <td align="center" valign="top"><table align="center" width="550" border="0" cellspacing="0" cellpadding="0" class="em_main_table" style="width:550px; table-layout:fixed;">
        <!-- A03 HEADER SECTION -->
        <tr>
          <td align="center" valign="top"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
              <tr>
                <td align="center" valign="top" bgcolor="#000000" style="padding:0 10px;"><table width="530" border="0" cellspacing="0" cellpadding="0" align="center" style="width:530px;" class="em_wrapper">
                    
                    <!-- HEADER SECTION -->
                    <tr>
                      <td  style="PADDING-BOTTOM: 22px; PADDING-TOP: 5px; PADDING-LEFT: 0px; PADDING-RIGHT: 0px" valign="top" align="center"><table cellspacing="0" cellpadding="0" align="center" border="0">
                          <tbody>
                            <!-- PREHEADER SECTION -->
                            <tr>
                              <td align="center" valign="top" style="padding:4px 0;"><table border="0" cellspacing="0" cellpadding="0" align="center">
                                  <tr>
                                    <td align="center" valign="top" style="font-family: 'Arial', sans-serif; font-size:11px; line-height:14px; color:#ffffff;">${safePh}</td>
                                  </tr>
                                </table></td>
                            </tr>
                            <!-- //PREHEADER SECTION -->
                            <tr>
                              <td align="center" valign="top" class="em_topbom" style="padding:24px 0 0 0;"><table border="0" cellspacing="0" cellpadding="0" align="center">
                                  <tr>
                                    <td align="center" valign="top"><a href="https://www.grainger.ca?cm_mmc=${trackingCode}" style="text-decoration:none;"><img src="http://t.e1.acklands.grainger.com/res/img/636B14955A5D8DC77E329D8A3E628C65.gif" width="230" height="80" alt="logo" title="logo" border="0" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#ffffff; font-weight:bold; max-width:230px;" /></a></td>
                                  </tr>
                                </table></td>
                            </tr>
                          </tbody>
                        </table></td>
                    </tr>
                    
                    <!-- //HEADER SECTION -->
                    
                  </table></td>
              </tr>
              
              <!-- NAVIGATION MENU -->
              <tr>
                <td bgcolor="#2a333b" valign="top" align="center"><table class="em_wrapper" style="TABLE-LAYOUT: fixed" cellspacing="0" cellpadding="0" width="550" align="center" border="0">
                    <tbody>
                      <tr>
                        <td valign="middle" align="center"><!--[if !mso]><!-->
                          
                          <input id="em_drop" style="OVERFLOW: hidden; WIDTH: 0px; FLOAT: left; DISPLAY: none !important; LINE-HEIGHT: 0; MAX-HEIGHT: 0px" type="checkbox"/>
                          <div class="showmenu" style="OVERFLOW: hidden; WIDTH: 0px; FLOAT: left; DISPLAY: none; LINE-HEIGHT: 0; MAX-HEIGHT: 0px">
                            <table style="MARGIN: 0px auto" cellspacing="0" cellpadding="0" align="center" border="0">
                              <tbody>
                                <tr>
                                  <td height="50" valign="middle" align="center"><label id="nav_handle" for="em_drop"></label></td>
                                  <td style="WIDTH: 10px" width="10">&nbsp;</td>
                                  <td style="FONT-SIZE: 20px; FONT-FAMILY: 'Roboto Condensed', 'Arial', sans-serif; FONT-WEIGHT: bold; COLOR: #ffffff" height="50" valign="middle" align="center"><label for="em_drop">MENU</label></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          
                          <!--<![endif]-->
                          
                          <div id="nav_menu" style="MARGIN-LEFT: 0px; Z-INDEX: 50; MARGIN-RIGHT: 0px"><!--<![endif]--><!--[if gte mso 9]>
	  <table width="550" border="0" cellspacing="0" cellpadding="0" align="left" class="em_wrapper">
	  <tr>
	  <td height="50" valign="middle" align="center" width="150">
	  <![endif]--><a class="em_wrapper2" style="FONT-SIZE: 14px; TEXT-DECORATION: none; FONT-FAMILY: 'Roboto Condensed', 'Arial', sans-serif; WIDTH: 145px; TEXT-TRANSFORM: uppercase; FLOAT: left; FONT-WEIGHT: bold; COLOR: #ffffff; DISPLAY: inline-block; LINE-HEIGHT: 50px" href="https://www.grainger.ca/en/login?frwdUrlPath=/my-account/&cm_mmc=${trackingCode}"><span 
			class="em_hide">&nbsp; </span>MY ACCOUNT</a><!--[if gte mso 9]>
	  </td>
	  <td height="50" valign="middle" align="center" width="150">
	  <![endif]--> 
                            <a class="em_wrapper2" style="FONT-SIZE: 14px; TEXT-DECORATION: none; FONT-FAMILY: 'Roboto Condensed', 'Arial', sans-serif; WIDTH: 145px; FLOAT: left; FONT-WEIGHT: bold; COLOR: #ffffff; DISPLAY: inline-block; LINE-HEIGHT: 50px" href="https://www.grainger.ca/en/category/c/1?cm_mmc=${trackingCode}">ALL PRODUCTS</a><!--[if gte mso 9]>
	  </td>
	  <td height="50" valign="middle" align="center" width="150">
	  <![endif]--> 
                            <a class="em_wrapper2" style="FONT-SIZE: 14px; TEXT-DECORATION: none; FONT-FAMILY: 'Roboto Condensed', 'Arial', sans-serif; WIDTH: 145px; FLOAT: left; FONT-WEIGHT: bold; COLOR: #ffffff; DISPLAY: inline-block; LINE-HEIGHT: 50px" href="https://www.grainger.ca/en/login?frwdUrlPath=/my-account/orderHistory&cm_mmc=${trackingCode}">ORDER 
                            HISTORY</a><!--[if gte mso 9]>
	  </td>
	  <td height="50" valign="middle" align="center">
	  <![endif]--> 
                            <a class="em_wrapper2" style="FONT-SIZE: 14px; TEXT-DECORATION: none; FONT-FAMILY: 'Roboto Condensed', 'Arial', sans-serif; WIDTH: 100px; FLOAT: left; FONT-WEIGHT: bold; COLOR: #ffffff; DISPLAY: inline-block; LINE-HEIGHT: 50px" href="https://www.grainger.ca/en/cart?from=%2Ffr%2Fcat%25C3%25A9gorie%2Fc%2F1%3Fanalytics%3Dnav%26aType%3Dbrc&cm_mmc=${trackingCode}">CART<span 
			class="em_hide">&nbsp;</span></a><!--[if gte mso 9]>
	  </td>
	  </tr>
	  </table>
	  <![endif]--> 
                          </div></td>
                      </tr>
                    </tbody>
                  </table></td>
              </tr>
              <!-- //NAVIGATION MENU -->
            </table></td>
        </tr>
      </table></td>
  </tr>
</table>
<table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
	 <tr>
    <td valign="top" align="center"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper" bgcolor="#FFFFFF">
        <tbody>
          <tr>
            <td><a href="${heroUrl}?cm_mmc=${trackingCode}"><img src="${tilefourFileName}" alt="hero" width="550" height="550" style="font-family: 'Arial', sans-serif; font-size: 22px; width: 550px; color: #000000; display: block;" title="hero" border="0"/></a></td>
          </tr>
        </tbody>
      </table></td>
  </tr>
</table>
<table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper" bgcolor="#8C1818">
  <tr>
  <td valign="top" align="center"><table width="550" height="15" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
    <tbody>
      <tr>
        <td height="15" style="height:15px;"></td>
      </tr>
    </tbody>
  </table></td>
</tr>
	<tr>
    <td valign="top" align="center"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
        <td valign="top"><a href="${heroOneUrl}&cm_mmc=${trackingCode}"><img src="${heroFileName}"  alt="ban2" width="183" height="171" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban2" border="0" /></a></td>
          <td valign="top"><a href="${heroTwoUrl}&cm_mmc=${trackingCode}"><img src="${tiletwoFileName}"  alt="ban3" width="183" height="171" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban3" border="0" /></a></td>
          <td valign="top"><a href="${heroThreeUrl}&cm_mmc=${trackingCode}"><img src="${tilethreeFileName}"  alt="ban4" width="183" height="171" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:184px; " title="ban4" border="0" /></a></td>
      </table>
	  </td>
  </tr>
  <tr>
    <td height="12" style="height:12px;"></td>
  </tr>
  <tr>
    <td height="12" style="height:12px;"></td>
  </tr>
</table>
<table bgcolor="#ffffff" width="550" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
  <tbody>
    <tr>
      <td>
      ${hasBanner === "No" ? `
        <table bgcolor="#ffffff" width="550" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
          <tbody>
			<tr>
               <td height="5" style="height:5px;"></td>
            </tr>
            <tr>
              <td colspan="3"><img class="em_img" style="font-family: 'Arial', sans-serif; width: 550px; color: #000000; display: block;" border="0" alt="b3ways" title="b3ways" src="31478E996A45F8D0436C0060907E1267.gif" width="550" height="36"/></td>
            </tr>
            <tr>
              <td valign="top"><a href="https://www.grainger.ca/en/content/contact-us?cm_mmc=${trackingCode}" style="text-decoration:none;"><img src="http://t.e1.acklands.grainger.com/res/img/C4D79A7C627B0C70343FD8814FC9199C.gif" width="183"  alt="b3ways" title="b3ways" border="0" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " /></a></td>
              <td valign="top"><a href="https://www.grainger.ca/en?analytics=nav?cm_mmc=${trackingCode}" style="text-decoration:none;"><img src="http://t.e1.acklands.grainger.com/res/img/107C1EA668DC791CC7B8D017557AA039.gif" width="183"  alt="b3ways" title="b3ways" border="0" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " /></a></td>
              <td valign="top"><a href="https://www.grainger.ca/en/content/find-branch-location?cm_mmc=${trackingCode}" style="text-decoration:none;"><img src="http://t.e1.acklands.grainger.com/res/img/D7A50E3E505C8F12B00A4327785FCF3C.gif" width="184"  alt="b3ways" title="b3ways" border="0" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:184px; " /></a></td>
            </tr>
            <tr>
              <td colspan="3" height="10" style="height:10px;" >&nbsp;</td>
            </tr>
          </tbody>
        </table>
        ` : `
        <table bgcolor="#ffffff" width="550" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
  <tbody>
    <tr>
      <td>
		  <table bgcolor="#ffffff" width="550" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
    <tbody>
      <tr>
        <td><a href="${secondaryBannerUrl}?cm_mmc=${trackingCode}" style="text-decoration:none;" target="_blank"><img class="em_img" style="font-family: 'Arial', sans-serif; width: 550px; color: #000000; display: block; " border="0" alt="${secondaryBannerFileName}" title="${secondaryBannerFileName}" src="${secondaryBannerFileName}" width="550" height="115"/></a></td>
      </tr>
        </tbody>
      </table>
	  </td>
    </tr>
  </tbody>
</table>
        `}
      </td>
    </tr>
  </tbody>
</table>
<table align="center" width="550" border="0" cellspacing="0" cellpadding="0" class="em_main_table" style="width:550px; table-layout:fixed;">
  <!-- F01 SOCIAL SECTION -->
  <tbody>
    <tr>
      <td 
          style="PADDING-BOTTOM: 25px; PADDING-TOP: 25px; PADDING-LEFT: 10px; PADDING-RIGHT: 10px" 
          bgcolor="#2a333b" valign="top" align="center"><table cellspacing="0" cellpadding="0" align="center" border="0">
          <tbody>
            <tr>
              <td valign="middle" align="center"><a style="TEXT-DECORATION: none" href="https://www.facebook.com/GraingerCanada/?cm_mmc=${trackingCode}"><img 
                  style="FONT-SIZE: 16px; MAX-WIDTH: 50px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; DISPLAY: block; LINE-HEIGHT: 50px" 
                  border="0" alt="facebook" 
                  src="http://t.e1.acklands.grainger.com/res/img/BBD24EC070059605A9645A5DFE160806.png" 
                  width="45" height="45"/></a></td>
              <td style="WIDTH: 20px" width="20">&nbsp;</td>

              <td valign="middle" align="center"><a style="TEXT-DECORATION: none" href="https://www.youtube.com/graingercanada?cm_mmc=${trackingCode}"><img 
                  style="FONT-SIZE: 16px; MAX-WIDTH: 50px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; DISPLAY: block; LINE-HEIGHT: 50px" 
                  border="0" alt="youtube" 
                  src="http://t.e1.acklands.grainger.com/res/img/2894A2E9B556F7DB16FF117A20426EE1.png" 
                  width="45" height="45"/></a></td>
              <td style="WIDTH: 20px" width="20">&nbsp;</td>
              <td valign="middle" align="center"><a style="TEXT-DECORATION: none" href="https://www.linkedin.com/company/graingercanada?cm_mmc=${trackingCode}"><img 
                  style="FONT-SIZE: 16px; MAX-WIDTH: 50px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; DISPLAY: block; LINE-HEIGHT: 50px" 
                  border="0" alt="linkedin" 
                  src="http://t.e1.acklands.grainger.com/res/img/7A31981414EDAE346169F26E55381B00.png" 
                  width="45" height="45"/></a></td>
            </tr>
          </tbody>
        </table></td>
    </tr>
    <!-- //F01 SOCIAL SECTION --> 
    <!-- F02 FOOTER SECTION -->
    <tr>
      <td 
          style="PADDING-BOTTOM: 0px; PADDING-TOP: 0px; PADDING-LEFT: 30px; PADDING-RIGHT: 30px" 
          bgcolor="#000000" valign="top" align="center"><table class="em_wrapper" style="WIDTH: 490px" cellspacing="0" 
            cellpadding="0" width="490" align="center" border="0">
          <tbody>
            <tr>
              <td class="em_defaultlink em_pad" 
                style="FONT-SIZE: 12px; FONT-FAMILY: 'Arial', sans-serif; FONT-WEIGHT: bold; COLOR: #ffffff; PADDING-BOTTOM: 0px; PADDING-TOP: 38px; PADDING-LEFT: 0px; LINE-HEIGHT: 16px; PADDING-RIGHT: 0px" 
                valign="top" align="center"><a style="TEXT-DECORATION: none; WHITE-SPACE: nowrap; COLOR: #ffffff" href="https://www.grainger.ca/en/login?frwdUrlPath=/my-account/&cm_mmc=${trackingCode}">My Account</a><span 
                  class="em_br414"></span><span class="em_hide414"> &nbsp;|&nbsp; </span><a style="TEXT-DECORATION: none; WHITE-SPACE: nowrap; COLOR: #ffffff" href="https://www.grainger.ca/en/content/contact-us?cm_mmc=${trackingCode}">Contact 
                Us</a> &nbsp;|&nbsp;<span></span><a style="TEXT-DECORATION: none; WHITE-SPACE: nowrap; COLOR: #ffffff" href="https://www.grainger.ca/en/content/find-branch-location?cm_mmc=${trackingCode}"> Find a Branch</a> &nbsp;|&nbsp; <a style="TEXT-DECORATION: none; WHITE-SPACE: nowrap; COLOR: #ffffff" href="https://www.grainger.ca/en/content/policies/privacy-policy?cm_mmc=${trackingCode}">Privacy 
                Policy</a> &nbsp;|&nbsp; <a style="TEXT-DECORATION: none; WHITE-SPACE: nowrap; COLOR: #ffffff" href="https://www.grainger.ca/en/emailSignUp/unsubscribe?email=<%=recipient.email%>&cm_mmc=${trackingCode}">Unsubscribe</a></td>
            </tr>
            <tr>
              <td 
                style="FONT-SIZE: 12px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; PADDING-BOTTOM: 0px; PADDING-TOP: 15px; PADDING-LEFT: 0px; LINE-HEIGHT: 16px; PADDING-RIGHT: 0px" 
                valign="top" align="left"><br/>
                <font color="#ffffff">This email was sent to email <a 
                  style="TEXT-DECORATION: none; COLOR: #ffffff" href="$clickthrough(#)$">&lt;%= recipient.email %&gt;</a></font>.<br/>
                <br/>
                To ensure delivery to your inbox, add <a href="mailto:grainger@b.grainger.ca" target="_top" style="color: #ffffff !important; text-decoration:none !important;"><font color="#ffffff">grainger@b.grainger.ca</font></a> to your address&nbsp;book.<br/>
                
                         ${showDiv === "Yes" ? `
                        <p>*Offers valid online only, no rain checks. Minimum order quantities may apply. Product availability and quantities may be limited and vary by region. Sign in to your registered online account for more details. &nbsp; 
                    ` : `<br/>
                    *On most in-stock orders placed by 5 PM (local shipping facility time) to most metropolitan areas, subject to carrier availability. Deliveries occur Monday–Friday, excluding holidays.`}
				
				<br /><br />
                <a href="https://www.grainger.ca/en/content/contact-us?cm_mmc=${trackingCode}" style="text-decoration: underline; color: inherit !important;"><font color="#ffffff">Questions</font></a>? Our Customer Service Centre is here to help you manage your orders, update&nbsp;an existing order, and place new ones.<br/>
                <br/>
                Acklands-Grainger Inc. &ldquo;Grainger&rdquo; &ldquo;Grainger Canada&rdquo; is a distributor of MRO products to businesses, and such products are to be used for business purposes only. We reserve the&nbsp;right to restrict sales of products unless business verification has been performed.<br/>
                <br/>
                Grainger Canada 123 Commerce Valley Drive East, Suite 700, Thornhill, Ontario&nbsp;L3T&nbsp;7W8</td>
            </tr>
            <tr>
              <td style="HEIGHT: 40px" 
          height="40">&nbsp;</td>
            </tr>
          </tbody>
        </table></td>
    </tr>
    
    <!-- //F02 FOOTER SECTION -->
    <tr>
      <td class="em_hide" style="line-height:1px;min-width:550px;background-color:#ffffff;"><img alt="" src="http://t.e1.acklands.grainger.com/res/img/F2229E22CDA170C551671E5853235FE1.gif" height="1"  width="550" style="max-height:1px; min-height:1px; display:block; width:550px; min-width:550px;" border="0" /></td>
    </tr>
  </tbody>
</table>
</body>
</html>
        `;

    try {
      if (window.showSaveFilePicker) {
        const handle = await window.showSaveFilePicker({
          suggestedName: fileName,
          types: [
            {
              description: "HTML Files",
              accept: { "text/html": [".html"] },
            },
          ],
        });

        const writable = await handle.createWritable();
        await writable.write(cvHtml);
        await writable.close();
        toast.success("File saved successfully!");
      } else {
        const blob = new Blob([cvHtml], { type: "text/html" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
        toast.success("File saved successfully!");
      }
      setFormData({
        sl: "",
        ph: "",
        trackingCode: "",
        trackingCodeHero: "",
        trackingCodeHeader: "",
        trackingCodeCta: "",
        trackingCodeBanner: "",
        trackingCodeFooter: "",
        cta: "",
        ctaUrl: "",
        body: "",
        showDiv: "No",
        heroOneUrl: "",
        heroTwoUrl: "",
        heroThreeUrl: "",
        heroUrl: "",
        hasBanner:"",
       
      });
      const heroInput = document.querySelector('input[name="hero"]');
      const tiletwoInput = document.querySelector('input[name="tileTwoImg"]');
      const tilethreeInput = document.querySelector('input[name="tileThreeImg"]');
      const tilefourInput = document.querySelector('input[name="tileFourImg"]');
      const ctaInput = document.querySelector('input[name="cta"]');
    
      if (heroInput) heroInput.value = "";
      if (ctaInput) ctaInput.value = "";
      if (tiletwoInput) tiletwoInput.value = "";
      if (tilethreeInput) tilethreeInput.value = "";
      if (tilefourInput) tilefourInput.value = "";
    } catch (error) {
      console.error("Error saving file:", error);
      toast.error("Failed to save the file!");
    }
  };
  return (
    <>
      <div className="container my-5">
        <div className="form-container">
          <h1 style={{ textAlign: "center" }}>GTA Email</h1>
          <form onSubmit={handleFormSubmit}>
            <div className="row">
              <div className="col-md-6">
                  <label>SL</label>
                <input
                  type="text"
                  name="sl"
                  value={formData.sl}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-6">
                  <label>PH</label>
                <input
                  type="text"
                  name="ph"
                  value={formData.ph}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-12">
                  <label>Tracking Code</label>
                <input
                  type="text"
                  name="trackingCode"
                  value={formData.trackingCode}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
              {/* <div className="col-md-6">
                  <label>Header Tracking Code</label>
                <input
                  type="text"
                  name="trackingCodeHeader"
                  value={formData.trackingCodeHeader}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-6">
                  <label>Hero Tracking Code</label>
                <input
                  type="text"
                  name="trackingCodeHero"
                  value={formData.trackingCodeHero}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-6">
                  <label>CTA Tracking Code</label>
                <input
                  type="text"
                  name="trackingCodeCta"
                  value={formData.trackingCodeCta}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-6">
                  <label>Secondary Banner Tracking Code</label>
                <input
                  type="text"
                  name="trackingCodeBanner"
                  value={formData.trackingCodeBanner}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-6">
                  <label>Footer Tracking Code</label>
                <input
                  type="text"
                  name="trackingCodeFooter"
                  value={formData.trackingCodeFooter}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div> */}
              <div className="col-md-6">
                  <label>Hero Banner</label>
                <input
                  type="file"
                  name="tileFourImg"
                  onChange={handleFileChange}
                  placeholder=""
                  required
                />
                </div>
              <div className="col-md-6">
                  <label>Hero Banner Url</label>
                <input
                  type="text"
                  name="heroUrl"
                  value={formData.heroUrl}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
                </div>
                
              <div className="col-md-6">
              <label>First Hero Icon</label>
                <input
                  type="file"
                  name="hero"
                  onChange={handleFileChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-6">
              <label>First Hero Url</label>
                <input
                  type="text"
                  name="heroOneUrl"
                  value={formData.heroOneUrl}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-6">
              <label>Second Hero Icon</label>
                <input
                  type="file"
                  name="tileTwoImg"
                  onChange={handleFileChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-6">
              <label>Second Hero Url</label>
                <input
                  type="text"
                  name="heroTwoUrl"
                  value={formData.heroTwoUrl}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-6">
              <label>Third Hero Icon</label>
                <input
                  type="file"
                  name="tileThreeImg"
                  onChange={handleFileChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-6">
              <label>Third Hero Url</label>
                <input
                  type="text"
                  name="heroThreeUrl"
                  value={formData.heroThreeUrl}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
              {/* <div className="col-md-6">
                  <label>CTA</label>
                <input
                  type="file"
                  name="cta"
                  onChange={handleFileChange}
                  placeholder=""
                  required
                />
              </div> */}
              {/* <div className="col-md-6">
                  <label>CTA Url</label>
                <input
                  type="text"
                  name="ctaUrl"
                  value={formData.ctaUrl}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div> */}
              <div className="col-md-12">
             <label>Secondary Banner</label>
             <select
          name="hasBanner"
          value={formData.hasBanner}
          onChange={handleInputChange}
          style={{ width: "100%", marginBottom: "10px", padding: "5px" }}
        >
          <option value="" hidden disabled>Select</option>
          <option value="No">Bottom tiles</option>
          <option value="Yes">Secondary Banner</option>
        </select>
             </div>
              {formData.hasBanner === "No" && (
          <>
             
          </>
        )}

        {formData.hasBanner === "Yes" && (
          <>
           <div className="col-md-6">
                  <label>Secondary Banner Image</label>
                <input
                  type="file"
                  name="secondaryBanner"
                  onChange={handleFileChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-6">
                  <label>Secondary Banner Url</label>
                <input
                  type="text"
                  name="secondaryBannerUrl"
                  value={formData.secondaryBannerUrl}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
          </>
        )}
          <div className="col-md-6">
          <label>Offer</label>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              name="showDiv"
              value="Yes"
              checked={formData.showDiv === "Yes"}
              onChange={handleInputChange}
            />{" "}
            On Offers
          </label>
          <label style={{ marginLeft: "10px" }}>
            <input
              type="radio"
              name="showDiv"
              value="No"
              checked={formData.showDiv === "No"}
              onChange={handleInputChange}
            />{" "}
            On most
          </label>
          </div>
           </div>
            </div>

            <button
              type="submit"
              style={{
                width: "100%",
                margin: "10px 0",
                padding: "10px",
                fontWeight: "bold",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Generate Email
            </button>
          </form>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};

export default GtaEn;
